import { render } from "./VersionDetail.vue?vue&type=template&id=55394265&scoped=true"
import script from "./VersionDetail.vue?vue&type=script&lang=js"
export * from "./VersionDetail.vue?vue&type=script&lang=js"

import "./VersionDetail.vue?vue&type=style&index=0&id=55394265&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55394265"]])

export default __exports__